import { withTheme } from "@emotion/react";
import { Grid2, Toolbar } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { useUserContext } from "../../contexts/UserContext";
import useNavigateTo from "../../hooks/useNavigateTo";
import { isNullOrEmpty } from "../../utils/helper";
import "./Navbar.scss";
// import NavbarMessagesDropdown from "./NavbarMessagesDropdown";
import NavbarLanguagesDropdown from "./NavbarLanguagesDropdown";
import NavbarNotificationsDropdown from "./NavbarNotificationsDropdown";
import NavbarUserDropdown from "./NavbarUserDropdown";

type NavbarProps = {
  showAppName: boolean;
  onDrawerToggle: React.MouseEventHandler<HTMLElement>;
  authorized: boolean;
};

const Navbar = (props: NavbarProps) => {
  const { navigateToDashboard } = useNavigateTo();
  const { user } = useUserContext();
  const { t } = useTranslation();

  const { showAppName, authorized } = props;

  return (
    <React.Fragment>
      <Toolbar className="navbar">
        <Grid2
          container
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Grid2
            className="navbar-app-name"
            sx={{
              display: { xs: "block", md: showAppName ? "block" : "none" },
            }}
          >
            <div onClick={() => navigateToDashboard()}>
              {t("supplierPortal")}
            </div>
          </Grid2>
          <Grid2></Grid2>
          <Grid2>
            {/* <NavbarMessagesDropdown /> */}
            {!isNullOrEmpty(user.accessToken) && (
              <NavbarNotificationsDropdown />
            )}
            <NavbarLanguagesDropdown />
            {!isNullOrEmpty(user.accessToken) && (
              <NavbarUserDropdown authorized={authorized} />
            )}
          </Grid2>
        </Grid2>
      </Toolbar>
    </React.Fragment>
  );
};

export default withTheme(Navbar);
